import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { CoreSearchDataState as AppState, getRegSearchState } from '../../../store/reducers/reducers';
import { UntypedFormBuilder, UntypedFormGroup, ValidationErrors } from '@angular/forms';
import { DocCategories2CIF } from '../../../shared/viewmodels/UtilityObj';

@Component({
  selector: 'app-doc-category-ex2',
  templateUrl: './doc-category-ex2.component.html',
  styleUrls: ['./doc-category-ex2.component.css']
})
export class DocCategoryEX2Component implements OnInit {

  public DocCategories2: DocCategories2CIF;
  public group: DocCategories2CIF;
  message: any;

  public form: UntypedFormGroup;

  constructor(private store: Store<AppState>, private fb: UntypedFormBuilder) {
    this.group = new DocCategories2CIF();
    this.store.select(getRegSearchState).subscribe(data => {
      this.message = data;
      console.log(`DocCategories2 from store: ${JSON.stringify(data.docCategories2[0])}`);
    });

    if (this.message.docCategories2[0] != null) {
      //this.DocCategories2.allDocuments = this.message.docCategories2[0].allDocuments;
      //this.DocCategories2.deeds = this.message.docCategories2[0].deeds;
      //this.DocCategories2.discharges = this.message.docCategories2[0].discharges;
      //this.DocCategories2.foreclosures = this.message.docCategories2[0].foreclosures;
      //this.DocCategories2.homestead = this.message.docCategories2[0].homestead;
      //this.DocCategories2.liensAndMortgages = this.message.docCategories2[0].liensAndMortgages;
      this.group = this.message.docCategories2[0];
      console.log(`group in control constructor: ${JSON.stringify(this.group)}`);
    }
  }

  ngOnInit() {
    this.form = this.fb.group({
      'group': [this.group.docCategory],
    });

    //This valueChanges subscription may not be necessary since
    //we have [ngModel] binding in the template.
    this.form.valueChanges.subscribe((value) => {
      console.log(`group valueChanges: ${JSON.stringify(value)}`);
      
      if (this.form.valid) {
        //this.DocCategories2.allDocuments = value.AllDocuments;
        //this.DocCategories2.discharges = value.Discharges;
        //this.DocCategories2.deeds = value.Deeds;
        //this.DocCategories2.foreclosures = value.Foreclosures;
        //this.DocCategories2.homestead = value.Homestead;
        //this.DocCategories2.liensAndMortgages = value.LiensAndMortgages;
        console.log(`value.group: ${JSON.stringify(value.group)}`);
        this.group.docCategory = value.group;
        console.log(`group in valueChanges: ${JSON.stringify(this.group)}`);

      }
    });

  }

  ValidateRequired(control: UntypedFormGroup): ValidationErrors | null {

    const deeds = control.get('Deeds').value;
    const hmstd = control.get('Homestead').value;//make sure this is boolean
    const frclsrs = control.get('Foreclosures').value;
    const liensAndMort = control.get('LiensAndMortgages').value;
    const discharges = control.get('Discharges').value;
    const alldocs = control.get('AllDocuments').value;

    if (!deeds && !hmstd && !frclsrs && !liensAndMort && !discharges && !alldocs) return {oneisrequired: true};

    return null;
  }

}
